import * as SubOfProjectTypeActionType from './constants';
import * as CommonActionType from '../Common/constants';

const defaultParams = {
  projectId: '',
  skip: 1,
  take: 10,
  sort: { field: 'phaseName', order: 'ascending' },
  totalRecord: 0,
  totalPage: 0
};

const ManageSubToProjects = {
  items: [],
  params: defaultParams
};

const SubToProjectState = {
  ManageSubToProjects: ManageSubToProjects,
  SelectListTrades: [],
  SelectListSubcontractors: [],
  SelectListPhases: [],
  ErrorMsg: []
};

export default function SubToProjectStore(state = SubToProjectState, action) {
  switch (action.type) {
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS:
      return processSelectListTrades(state, action);
    case CommonActionType.COMMON_SELECT_LIST_SUBCONTRACTOR_SUCCESS:
      return processSelectListSubcontractors(state, action);
    case CommonActionType.COMMON_SELECT_LIST_PHASE_SUCCESS:
      return processSelectListPhases(state, action);
    case SubOfProjectTypeActionType.ASSIGN_SUB_OF_PROJECT_SUCCESS:
      return processAssignSubToProjectSuccess(state, action);
    case SubOfProjectTypeActionType.SEARCH_SUB_OF_PROJECT_SUCCESS:
      return processSearchSuccess(state, action);
    case SubOfProjectTypeActionType.RESET_SUB_OF_PROJECT:
      return {
        ...state,
        SelectListTrades: [],
        SelectListSubcontractors: [],
        SelectListPhases: [],
        ErrorMsg: []
      };
    default:
      return state;
  }
}

const processSelectListTrades = (state, action) => {

  return {
    ...state,
    SelectListTrades: action.data
  };
};

const processSelectListSubcontractors = (state, action) => {
  return {
    ...state,
    SelectListSubcontractors: action.data
  };
};

const processSelectListPhases = (state, action) => {
  return {
    ...state,
    SelectListPhases: action.data
  };
};

const processSearchSuccess = (state, action) => {

  var result = action.data;

  var manageSubToProjects = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };

  return {
    ...state,
    ManageSubToProjects: manageSubToProjects
  };
};

const processAssignSubToProjectSuccess = (state) => {
  return {
    ...state,
    SelectListTrades: [],
    SelectListSubcontractors: [],
    ErrorMsg: []
  };
};



// WEBPACK FOOTER //
// ./src/Subcontractors/sub-of-project-store.js